import { Container, Typography, Box } from '@frontierag/frontier-ui-library';

import { styles } from './styles';
import type { ISubHeader } from './types';

const SubHeader = ({ title }: ISubHeader) => {
  return (
    <Box minHeight={{ xs: 68, sm: 72 }} sx={styles.container} data-testid="page-title">
      <Container maxWidth="lg">
        <Typography variant="subtitle2" noWrap>
          {title}
        </Typography>
      </Container>
    </Box>
  );
};

export default SubHeader;
